import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import useRouter from '@velzon/Hooks/useRouter.js';
import { handleLogOut } from '@velzon/utils/auth/index.js';
import { logout } from 'api/authentication/auth.js';
import { useSelector } from 'react-redux';

const ProfileDropdown = () => {
  const user = useSelector((state) => state.auth.user);

  const userName = user?.name;
  const userEmail = user?.email;
  const userInitial = (userName || 'Admin').trim().charAt(0).toUpperCase();
  const router = useRouter();
  async function handleLogout () {
    await logout()
    handleLogOut()
    router.push("/login")
  }
  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
        style={{ background: 'transparent' }}
      >
        <DropdownToggle tag="button" type="button" className="btn border-0 shadow-none px-2">
          <span className="d-flex align-items-center" style={{ gap: 10 }}>
            <span
              className="rounded-circle d-flex align-items-center justify-content-center text-white fw-semibold flex-shrink-0"
              style={{
                width: 36,
                height: 36,
                fontSize: 15,
                background: 'linear-gradient(160deg, #cf4518 0%, #b23a13 100%)' // PostHubb logo red
              }}
              aria-hidden="true"
            >
              {userInitial}
            </span>
            <span className="d-none d-xl-block text-start" style={{ lineHeight: 1.25 }}>
              <span className="d-block fw-semibold" style={{ fontSize: 15, color: '#11202b' }}>{userName || 'Admin'}</span>
              <span className="d-block fw-medium" style={{ fontSize: 12, color: '#576a78' }}>Administrator</span>
            </span>
            <i
              className={`d-none d-xl-inline-block ${isProfileDropdown ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}
              style={{ fontSize: 18, color: '#576a78' }}
              aria-hidden="true"
            />
          </span>
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-end p-0 overflow-hidden"
          style={{
            minWidth: 250,
            background: '#ffffff',
            border: '1px solid #d5e0e7',
            borderRadius: 12,
            boxShadow: '0 8px 24px rgba(17, 32, 43, 0.08)'
          }}
        >
          <div
            className="text-center px-3 py-3"
            style={{ background: '#ffffff', borderBottom: '1px solid #d6e1e7', borderRadius: '0 0 12px 12px' }}
          >
            <div className="fw-semibold text-truncate" style={{ fontSize: 15, color: '#11202b' }} title={userName}>
              {userName || 'Admin'}
            </div>
            {userEmail && (
              <div className="text-muted text-truncate mt-1" style={{ fontSize: 13 }} title={userEmail}>
                {userEmail}
              </div>
            )}
            <span
              className="badge rounded-pill fw-semibold mt-2 px-2 py-1"
              style={{ fontSize: 11, background: '#f9e9e3', color: '#b23a13' }}
            >
              Admin
            </span>
          </div>
          <div className="d-flex justify-content-center p-2">
            <DropdownItem
              tag="button"
              type="button"
              onClick={handleLogout}
              className="d-inline-flex align-items-center justify-content-center fw-semibold rounded-pill w-auto px-4 py-2"
              style={{ gap: 8, background: '#edf2f5', color: '#11202b' }}
            >
              <i className="mdi mdi-logout fs-16" />
              <span data-key="t-logout">Sign Out</span>
            </DropdownItem>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;